// extracted by mini-css-extract-plugin
export var colorOverlay = "statGrid-module--color-overlay--f8eb3";
export var eyebrow = "statGrid-module--eyebrow--a181b";
export var headingContainer = "statGrid-module--heading-container--bfdca";
export var stat = "statGrid-module--stat--12c55";
export var statContainer = "statGrid-module--stat-container--1c924";
export var statGrid = "statGrid-module--stat-grid--884f1";